import {adultTeeth, babyTeeth, teethLabels} from "@/dictionaries/dictionary"

const toothName = (toothCode, translateFunction) => {
	return toothCode in teethLabels ? translateFunction(teethLabels[toothCode]) : translateFunction('tooth')+' '+toothCode
}

const deductToothViewFromTeeth = (teeth) => {
	const adultCount = teeth.filter(tooth => adultTeeth.includes(tooth)).length
	const babyCount = teeth.filter(tooth => babyTeeth.includes(tooth)).length

	return babyCount > adultCount ? 'BabyTeeth' : 'AdultTeeth'
}

const ensureGroupIndexes = (teeth) => {
	let runningIndex = 0
	for(const tooth of teeth) {
		if(!tooth.teeth && tooth.tooth) tooth.teeth = tooth.tooth // for plan visits
		if(tooth.group_index === null) {
			tooth.group_index = runningIndex
			runningIndex++
		}
	}
}

const fetchVisitTeeth = (visit) => {
	if(visit?.type === 'plan_visit') return visit?.teeth || []
	return visit?.record_teeth || []
}

const calculateAppliedVsTotalStats = (visit, teeth = null, serviceId = null) => {
	const res = {
		applied: 0,
		qty: 0
	}
	const teethInGroups = (teeth || []).map(t => t.id)
	const allAppliedTeeth = visit?.teethDataWithApplied || []
	allAppliedTeeth.forEach(appliedTooth => {
		if(!teeth || teethInGroups.includes(appliedTooth.id)) {
			const services = Object.values(appliedTooth.servicesQuantified || {})
			services.forEach(service => {
				if(!serviceId || service.id === serviceId) {
					res.applied += service.applied
					res.qty += service.qty
				}
			})
		}
	})
	res.status = res.qty > 0 && res.qty === res.applied ? 'finished' : 'in_progress'
	return res
}

export {
	toothName,
	deductToothViewFromTeeth,
	ensureGroupIndexes,
	fetchVisitTeeth,
	calculateAppliedVsTotalStats
}

